import { Link } from "react-router-dom";

import { useQuery } from "@tanstack/react-query";

import { initUseQuery } from "simplydo/core/query";
import { Button, Divider, Icon } from "simplydo/react/ui";

import api from "api";
import { useAppSelector } from "store";
import util from "utils/utils";

import RowComponent from "components/lib/RowComponent";

const HomeInnovationIntelligence = () => {
  const user = useAppSelector((state) => state.user);

  const innoIntelEnabled =
    util.organisationFeaturesEnabled(user, ["innovationIntelligence"]) &&
    util.hasPermission(
      user,
      "org.innovationIntelligence",
      user?.ownerOrganisation?._id,
    );

  const myListsQuery = useQuery(
    initUseQuery(api.innointel.getLists, [], { isEnabled: innoIntelEnabled }),
  );

  if (!innoIntelEnabled) return null;
  return (
    <RowComponent>
      <RowComponent.Fill>
        <RowComponent.Title to="/innointel" wrapping>
          Innovation Intelligence
        </RowComponent.Title>
        <Button
          primary
          size="mini"
          content="View companies"
          as={Link}
          to="/innointel"
        />
      </RowComponent.Fill>
      <RowComponent.Cell as={Link} to={"/innointel"}>
        <Icon name="building" size="large" />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginLeft: 5,
            marginRight: 5,
            position: "relative",
            top: -1,
          }}
        >
          <RowComponent.Title style={{ color: "#5d5d5d" }} block>
            Business Search
          </RowComponent.Title>
          <RowComponent.StatusArea>
            Companies and organisations worldwide
          </RowComponent.StatusArea>
        </div>
      </RowComponent.Cell>
      <RowComponent.Cell as={Link} to="/innointel/dashboards/">
        <Icon name="detective" size="large" />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginLeft: 5,
            marginRight: 5,
            position: "relative",
            top: -1,
          }}
        >
          <RowComponent.Title style={{ color: "#5d5d5d" }} block>
            Industry Dashboards
          </RowComponent.Title>
          <RowComponent.StatusArea>
            Innovation landscape of a specific industry
          </RowComponent.StatusArea>
        </div>
      </RowComponent.Cell>

      {(myListsQuery.data?.lists?.length ?? 0) > 0 ?
        <>
          <Divider hidden />
          <RowComponent.Fill>
            <RowComponent.Title>Your company lists</RowComponent.Title>
          </RowComponent.Fill>
          {myListsQuery.data?.lists.map((list) => (
            <RowComponent.Cell
              key={list._id}
              as={Link}
              to={`/innointel/lists/${list._id}`}
              style={{ padding: "5px 5px" }}
            >
              <Icon name="list" size="large" />
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginLeft: 5,
                  marginRight: 5,
                  position: "relative",
                  top: -1,
                }}
              >
                <RowComponent.Title style={{ color: "#5d5d5d" }} block>
                  {list.name}
                </RowComponent.Title>
                <RowComponent.StatusArea>
                  {list.companies?.length ?? 0} companies
                  {user && (list as { user?: string }).user !== user._id ?
                    ", shared with you."
                  : ""}
                </RowComponent.StatusArea>
              </div>
            </RowComponent.Cell>
          ))}
        </>
      : null}
    </RowComponent>
  );
};

export default HomeInnovationIntelligence;
